export enum UserType {
    CustomerUser,
    LocalInternalUser,
    RegionalInternalUser
}
